var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOrganicBackArrow = function SvgOrganicBackArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 16,
    viewBox: "0 0 72 16",
    fill: "#432F24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8a8 8 0 1 0 16 0A8 8 0 0 0 0 8Zm8 1.5h64v-3H8v3Z"
  })));
};
export default SvgOrganicBackArrow;